module.exports = __webpack_public_path__ + "static/img/mando-pr.4746ff8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/mando-pr.jpg
// module id = RxXa
// module chunks = 0